import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import client from '../api/client';

export default function CancelBooking() {
  const { token }   = useParams();
  const [status,    setStatus]  = useState('loading'); // loading | success | already_cancelled | error
  const [booking,   setBooking] = useState(null);
  const [errorMsg,  setErrorMsg]= useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setErrorMsg('Invalid cancel link.'); return; }
    client.get(`/api/calendar/cancel/${token}`)
      .then(({ data }) => {
        setBooking(data.booking);
        setStatus('success');
      })
      .catch(err => {
        const msg = err.response?.data?.error || 'Something went wrong.';
        if (msg.toLowerCase().includes('already cancelled')) {
          setStatus('already_cancelled');
        } else {
          setStatus('error');
          setErrorMsg(msg);
        }
      });
  }, [token]); // eslint-disable-line

  const primary    = booking?.page?.color || '#0099FF';
  const bookingUrl = booking?.page?.slug
    ? `https://app.digitalxtension.com/book/${booking.page.slug}`
    : null;

  return (
    <div style={{minHeight:'100vh',background:'#f5f7fa',fontFamily:"'Inter',system-ui,sans-serif",display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:20}}>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css" />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      <div style={{background:'#fff',borderRadius:16,maxWidth:460,width:'100%',overflow:'hidden',boxShadow:'0 4px 24px rgba(0,0,0,0.08)'}}>

        {/* Header strip */}
        <div style={{background:primary,padding:'28px 32px',textAlign:'center'}}>
          {status === 'loading' && (
            <div style={{width:40,height:40,border:'3px solid rgba(255,255,255,0.3)',borderTop:'3px solid #fff',borderRadius:'50%',animation:'spin 0.8s linear infinite',margin:'0 auto'}} />
          )}
          {status === 'success' && (
            <i className="ti ti-calendar-x" style={{fontSize:40,color:'#fff',display:'block'}} />
          )}
          {(status === 'already_cancelled') && (
            <i className="ti ti-info-circle" style={{fontSize:40,color:'#fff',display:'block'}} />
          )}
          {status === 'error' && (
            <i className="ti ti-alert-circle" style={{fontSize:40,color:'#fff',display:'block'}} />
          )}
          <div style={{fontSize:18,fontWeight:700,color:'#fff',marginTop:12}}>
            {status === 'loading'           && 'Cancelling your booking...'}
            {status === 'success'           && 'Booking Cancelled'}
            {status === 'already_cancelled' && 'Already Cancelled'}
            {status === 'error'             && 'Something went wrong'}
          </div>
        </div>

        {/* Body */}
        <div style={{padding:'28px 32px',textAlign:'center'}}>

          {status === 'loading' && (
            <p style={{color:'#6b7280',fontSize:14}}>Please wait while we process your cancellation...</p>
          )}

          {status === 'success' && (
            <>
              <p style={{color:'#374151',fontSize:15,marginBottom:8}}>
                Hi <strong>{booking?.booker_name}</strong>,
              </p>
              <p style={{color:'#6b7280',fontSize:14,lineHeight:1.7,marginBottom:20}}>
                Your booking for <strong>{booking?.page?.title || 'your appointment'}</strong>
                {booking?.start_time && (
                  <> on <strong>{new Date(booking.start_time).toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</strong></>
                )} has been successfully cancelled. You will receive a confirmation email shortly.
              </p>
              {bookingUrl && (
                <>
                  <p style={{color:'#6b7280',fontSize:14,marginBottom:16}}>Would you like to book another time?</p>
                  <a href={bookingUrl}
                    style={{display:'inline-block',background:primary,color:'#fff',textDecoration:'none',padding:'12px 28px',borderRadius:10,fontWeight:600,fontSize:14}}>
                    Book Again →
                  </a>
                </>
              )}
            </>
          )}

          {status === 'already_cancelled' && (
            <>
              <p style={{color:'#6b7280',fontSize:14,lineHeight:1.7,marginBottom:20}}>
                This booking has already been cancelled. No further action is needed.
              </p>
              {bookingUrl && (
                <a href={bookingUrl}
                  style={{display:'inline-block',background:primary,color:'#fff',textDecoration:'none',padding:'12px 28px',borderRadius:10,fontWeight:600,fontSize:14}}>
                  Book a New Appointment →
                </a>
              )}
            </>
          )}

          {status === 'error' && (
            <p style={{color:'#EF4444',fontSize:14,lineHeight:1.7}}>
              {errorMsg || 'We could not process your cancellation. The link may be invalid or expired.'}
            </p>
          )}
        </div>

        {/* Footer */}
        <div style={{background:'#f9fafb',padding:'14px 32px',textAlign:'center',borderTop:'1px solid #e5e7eb'}}>
          <p style={{color:'#9ca3af',fontSize:11,margin:0}}>Powered by Digital Xtension CRM</p>
        </div>
      </div>
    </div>
  );
}
